// Generated from grammarLexer.g4 by ANTLR 4.13.2
// jshint ignore: start
import antlr4 from "antlr4";

const serializedATN = [
  4, 0, 16, 83, 6, -1, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7,
  4, 2, 5, 7, 5, 2, 6, 7, 6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9, 2, 10, 7, 10,
  2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13, 2, 14, 7, 14, 2, 15, 7, 15, 1, 0, 1,
  0, 1, 0, 1, 0, 4, 0, 38, 8, 0, 11, 0, 12, 0, 39, 1, 1, 1, 1, 1, 1, 4, 1, 45,
  8, 1, 11, 1, 12, 1, 46, 1, 2, 1, 2, 1, 2, 1, 3, 1, 3, 4, 3, 54, 8, 3, 11, 3,
  12, 3, 55, 1, 4, 1, 4, 1, 5, 1, 5, 1, 6, 1, 6, 1, 7, 1, 7, 1, 8, 1, 8, 1, 9,
  1, 9, 1, 10, 1, 10, 1, 11, 1, 11, 1, 12, 1, 12, 1, 13, 1, 13, 1, 14, 1, 14, 1,
  15, 1, 15, 1, 15, 1, 15, 0, 0, 16, 1, 1, 3, 2, 5, 3, 7, 4, 9, 5, 11, 6, 13, 7,
  15, 8, 17, 9, 19, 10, 21, 11, 23, 12, 25, 13, 27, 14, 29, 15, 31, 16, 1, 0, 5,
  1, 0, 97, 122, 1, 0, 65, 90, 1, 0, 48, 57, 11, 0, 33, 33, 35, 38, 40, 44, 46,
  46, 58, 59, 61, 61, 63, 64, 91, 91, 93, 94, 123, 123, 125, 126, 3, 0, 9, 9,
  12, 13, 32, 32, 90, 0, 1, 1, 0, 0, 0, 0, 3, 1, 0, 0, 0, 0, 5, 1, 0, 0, 0, 0,
  7, 1, 0, 0, 0, 0, 9, 1, 0, 0, 0, 0, 11, 1, 0, 0, 0, 0, 13, 1, 0, 0, 0, 0, 15,
  1, 0, 0, 0, 0, 17, 1, 0, 0, 0, 0, 19, 1, 0, 0, 0, 0, 21, 1, 0, 0, 0, 0, 23, 1,
  0, 0, 0, 0, 25, 1, 0, 0, 0, 0, 27, 1, 0, 0, 0, 0, 29, 1, 0, 0, 0, 0, 31, 1, 0,
  0, 0, 1, 37, 1, 0, 0, 0, 3, 44, 1, 0, 0, 0, 5, 48, 1, 0, 0, 0, 7, 51, 1, 0, 0,
  0, 9, 57, 1, 0, 0, 0, 11, 59, 1, 0, 0, 0, 13, 61, 1, 0, 0, 0, 15, 63, 1, 0, 0,
  0, 17, 65, 1, 0, 0, 0, 19, 67, 1, 0, 0, 0, 21, 69, 1, 0, 0, 0, 23, 71, 1, 0,
  0, 0, 25, 73, 1, 0, 0, 0, 27, 75, 1, 0, 0, 0, 29, 77, 1, 0, 0, 0, 31, 79, 1,
  0, 0, 0, 33, 38, 3, 11, 5, 0, 34, 38, 3, 3, 1, 0, 35, 38, 3, 5, 2, 0, 36, 38,
  3, 7, 3, 0, 37, 33, 1, 0, 0, 0, 37, 34, 1, 0, 0, 0, 37, 35, 1, 0, 0, 0, 37,
  36, 1, 0, 0, 0, 38, 39, 1, 0, 0, 0, 39, 37, 1, 0, 0, 0, 39, 40, 1, 0, 0, 0,
  40, 2, 1, 0, 0, 0, 41, 45, 3, 9, 4, 0, 42, 45, 3, 13, 6, 0, 43, 45, 3, 25, 12,
  0, 44, 41, 1, 0, 0, 0, 44, 42, 1, 0, 0, 0, 44, 43, 1, 0, 0, 0, 45, 46, 1, 0,
  0, 0, 46, 44, 1, 0, 0, 0, 46, 47, 1, 0, 0, 0, 47, 4, 1, 0, 0, 0, 48, 49, 3,
  11, 5, 0, 49, 50, 3, 15, 7, 0, 50, 6, 1, 0, 0, 0, 51, 53, 3, 11, 5, 0, 52, 54,
  3, 27, 13, 0, 53, 52, 1, 0, 0, 0, 54, 55, 1, 0, 0, 0, 55, 53, 1, 0, 0, 0, 55,
  56, 1, 0, 0, 0, 56, 8, 1, 0, 0, 0, 57, 58, 7, 0, 0, 0, 58, 10, 1, 0, 0, 0, 59,
  60, 7, 1, 0, 0, 60, 12, 1, 0, 0, 0, 61, 62, 7, 2, 0, 0, 62, 14, 1, 0, 0, 0,
  63, 64, 5, 39, 0, 0, 64, 16, 1, 0, 0, 0, 65, 66, 5, 95, 0, 0, 66, 18, 1, 0, 0,
  0, 67, 68, 5, 8594, 0, 0, 68, 20, 1, 0, 0, 0, 69, 70, 5, 955, 0, 0, 70, 22, 1,
  0, 0, 0, 71, 72, 5, 124, 0, 0, 72, 24, 1, 0, 0, 0, 73, 74, 7, 3, 0, 0, 74, 26,
  1, 0, 0, 0, 75, 76, 2, 8320, 8329, 0, 76, 28, 1, 0, 0, 0, 77, 78, 5, 10, 0, 0,
  78, 30, 1, 0, 0, 0, 79, 80, 7, 4, 0, 0, 80, 81, 1, 0, 0, 0, 81, 82, 6, 15, 0,
  0, 82, 32, 1, 0, 0, 0, 6, 0, 37, 39, 44, 46, 55, 1, 6, 0, 0,
];

const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map(
  (ds, index) => new antlr4.dfa.DFA(ds, index)
);

export default class grammarLexer extends antlr4.Lexer {
  static grammarFileName = "grammarLexer.g4";
  static channelNames = ["DEFAULT_TOKEN_CHANNEL", "HIDDEN"];
  static modeNames = ["DEFAULT_MODE"];
  static literalNames = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    "'''",
    "'_'",
    "'\\u2192'",
    "'\\u03BB'",
    "'|'",
    null,
    null,
    "'\\n'",
  ];
  static symbolicNames = [
    null,
    "WDCOMPLEX",
    "WDSYMDIG",
    "APOSUPPW",
    "UNIUPPW",
    "LOWW",
    "UPPW",
    "DIGITS",
    "APOSTROPHE",
    "UNDERSCORE",
    "ARROW",
    "LAMBDA",
    "PIPE",
    "SYMBOLS",
    "NUMUNI",
    "NEWLINE",
    "WS",
  ];
  static ruleNames = [
    "WDCOMPLEX",
    "WDSYMDIG",
    "APOSUPPW",
    "UNIUPPW",
    "LOWW",
    "UPPW",
    "DIGITS",
    "APOSTROPHE",
    "UNDERSCORE",
    "ARROW",
    "LAMBDA",
    "PIPE",
    "SYMBOLS",
    "NUMUNI",
    "NEWLINE",
    "WS",
  ];

  constructor(input) {
    super(input);
    this._interp = new antlr4.atn.LexerATNSimulator(
      this,
      atn,
      decisionsToDFA,
      new antlr4.atn.PredictionContextCache()
    );
  }
}

grammarLexer.EOF = antlr4.Token.EOF;
grammarLexer.WDCOMPLEX = 1;
grammarLexer.WDSYMDIG = 2;
grammarLexer.APOSUPPW = 3;
grammarLexer.UNIUPPW = 4;
grammarLexer.LOWW = 5;
grammarLexer.UPPW = 6;
grammarLexer.DIGITS = 7;
grammarLexer.APOSTROPHE = 8;
grammarLexer.UNDERSCORE = 9;
grammarLexer.ARROW = 10;
grammarLexer.LAMBDA = 11;
grammarLexer.PIPE = 12;
grammarLexer.SYMBOLS = 13;
grammarLexer.NUMUNI = 14;
grammarLexer.NEWLINE = 15;
grammarLexer.WS = 16;
